/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { MenuScreenAdminDto } from '../models/MenuScreenAdminDto';
import type { PostMenuScreenRequestAdmin } from '../models/PostMenuScreenRequestAdmin';
import type { PutMenuScreenRequestAdmin } from '../models/PutMenuScreenRequestAdmin';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class MenuScreensService {
    /**
     * **Required Policy:** `ViewMenuScreens`
     * @returns MenuScreenAdminDto OK
     * @throws ApiError
     */
    public static getMenuScreensAdmin({
        isActive,
    }: {
        isActive?: boolean,
    }): CancelablePromise<Array<MenuScreenAdminDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/menuscreens',
            query: {
                'isActive': isActive,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageMenuScreens`
     * @returns MenuScreenAdminDto OK
     * @throws ApiError
     */
    public static createMenuScreenAdmin({
        requestBody,
    }: {
        requestBody?: PostMenuScreenRequestAdmin,
    }): CancelablePromise<MenuScreenAdminDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/v1/menuscreens',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageMenuScreens`
     * @returns MenuScreenAdminDto OK
     * @throws ApiError
     */
    public static updateMenuScreenAdmin({
        id,
        requestBody,
    }: {
        id: string,
        requestBody?: PutMenuScreenRequestAdmin,
    }): CancelablePromise<MenuScreenAdminDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/admin/v1/menuscreens/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageMenuScreens`
     * @returns any OK
     * @throws ApiError
     */
    public static deleteMenuScreenAdmin({
        id,
    }: {
        id: string,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/admin/v1/menuscreens/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
}
